export default __webpack_public_path__ + "static/media/companyIconLight.2f4ee08b.svg";